import { dispatchTrackingEvent } from '@context/tracking/utils';

import { FullfilledSteps } from './components/HowToLoyaltyDiscountModal';

export enum LoyaltyStatus {
  nonRegistered = 'non-registered',
  registered = 'registered',
  subscribed = 'subscribed',
  activated = 'activated',
  unsubscribed = 'unsubscribed',
}

export const determineStatus = (fullfilledSteps: FullfilledSteps) => {
  let status = LoyaltyStatus.nonRegistered;

  if (fullfilledSteps.registerStep) {
    status = LoyaltyStatus.registered;
  }

  if (fullfilledSteps.registerStep && fullfilledSteps.newsletterStep) {
    status = LoyaltyStatus.subscribed;
  }

  if (
    fullfilledSteps.registerStep &&
    fullfilledSteps.chooseBrandAndCategoryStep &&
    !fullfilledSteps.newsletterStep
  ) {
    status = LoyaltyStatus.unsubscribed;
  }

  return status;
};

export const trackLoyaltyModalOpen = (
  status: LoyaltyStatus,
  timing: number
) => {
  dispatchTrackingEvent({
    event: 'subpage_view',
    _clear: true,
    subpage: {
      name: `/overlay_vip-discount/${status}/`,
      action: 'open_vip_overlay',
      interaction: 'click',
      type: 'service',
      title: 'VIP program',
      timing,
    },
  });
};

export const trackLoyaltyModalClose = () =>
  dispatchTrackingEvent({
    event: 'subpage_close',
    subpage: undefined,
    _clear: true,
  });
